import { render, staticRenderFns } from "./indexOne.vue?vue&type=template&id=2290bcd4&scoped=true"
import script from "./indexOne.vue?vue&type=script&lang=js"
export * from "./indexOne.vue?vue&type=script&lang=js"
import style0 from "./indexOne.vue?vue&type=style&index=0&id=2290bcd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2290bcd4",
  null
  
)

export default component.exports